import { useState } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Header from './components/header';
import SignIn from './components/modal/SignIn';
import SignUp from './components/modal/SignUp';
import ScrollToTop from './components/util/ScrollToTop';
import AppContext from './contexts/AppContext'
import AddMessage from './pages/AddMessage';
import AddressBook from './pages/AddressBook';
import Basket from './pages/Basket';
import Customizable from './pages/Customizable';
import Main from './pages/Main';
import NotFound from './pages/NotFound';
import OnItsWay from './pages/OnItsWay';
import PastOrders from './pages/PastOrders';
import PaymentMethods from './pages/PaymentMethods';
import Subscriptions from './pages/Subscriptions';
import Templates from './pages/Templates';
import ThanksForSubscribing from './pages/ThanksForSubscribing';

import './style.scss';

function App() {
    const [user, setUser] = useState();
    const [page, setPage] = useState('');
    const [allCategories, setAllCategories] = useState('');
    const [basket, setBasket] = useState('');
    const [popup, setPopup] = useState('');
    const [showUserSettings, setShowUserSettings] = useState('');
    const [testMode, setTestMode] = useState(false);
    const [fonts, setFonts] = useState([
        {name:"Open Sans", className:"openSans"},    
        {name:"Montserrat", className:"montserrat"},
        {name:"Lato", className:"lato"},
        {name:"Oswald",className:"oswald"},
        {name:"Quicksand",className:"quicksand"},
        {name:"Josefin Slab",className:"josefinSlab"},
        {name:"Merriweather",className:"merriweather"},
        {name:"Libre Baskerville", className:"libreBaskerville"},
        {name:"Source Serif Pro",className:"sourceSerifPro"},
        {name:"EB Garamond",className:"eBGaramond"},
        {name:"Roboto Slab",className:"robotoSlab"},
        {name:"Arvo",className:"arvo"},
        {name:"Playfair Display",className:"playfairDisplay"},
        {name:"Lobster", className:"lobster"},
        {name:"Pacifico", className:"pacifico"},
        {name:"Bellefair", className:"bellefair"},
        {name:"Utra", className:"utra"},
        {name:"hwRuthie", className:"hwRuthie big"},
        {name:"hwRyan", className:"hwRyan big"},
        {name:"hwCharity", className:"hwCharity big"},
        {name:"hwSaige", className:"hwSaige big"},
        {name:"hwLulu", className:"hwLulu big"},
        {name:"hwErin", className:"hwErin big"},
        {name:"hwRachael", className:"hwRachael big"},
        {name:"hwChase", className:"hwChase big"},
        {name:"hwAdam", className:"hwAdam big"},
        {name:"hwSteve", className:"hwSteve big"},
        {name:"hwKelsey", className:"hwKelsey big"},
        {name:"hwMason", className:"hwMason big"},
        {name:"hwJeff", className:"hwJeff big"},
        {name:"hwMichael", className:"hwMichael big"},
        {name:"hwDavid", className:"hwDavid big"},
        {name:"hwDarleen", className:"hwDarleen big"},
        {name:"hwWill", className:"hwWill big"},
        {name:"hwNick", className:"hwNick big"},
        {name:"hwJenna", className:"hwJenna big"}
    ]);

    return (
        <BrowserRouter>
            <AppContext.Provider value={{ user, setUser, page, setPage, allCategories, setAllCategories, basket, setBasket, popup, setPopup, showUserSettings, setShowUserSettings, fonts, setFonts, testMode, setTestMode }}>
                <ScrollToTop>
                    <Header />
                    <main>
                        <Switch>
                            <Route path="/payment-methods" exact><PaymentMethods /></Route>
                            <Route path="/address-book" exact><AddressBook /></Route>
                            <Route path="/message-templates" exact><Templates /></Route>
                            <Route path="/customizable" exact><Customizable /></Route>
                            <Route path="/thanks-for-subscribing" exact><ThanksForSubscribing /></Route>
                            <Route path="/subscriptions" exact><Subscriptions /></Route>
                            <Route path="/past-orders" exact><PastOrders /></Route>
                            <Route path="/on-its-way" exact><OnItsWay /></Route>
                            <Route path="/my-basket" exact><Basket /></Route>
                            <Route path="/bulk-order" exact><AddMessage bulk={true} /></Route>
                            <Route path="/add-message/(complete-order)?" exact><AddMessage /></Route>
                            <Route path="/signup" exact><SignUp relative={true} /></Route>
                            <Route path="/signin" exact><SignIn relative={true} /></Route>
                            <Route path="/category/:title?" exact><Main /></Route>
                            <Route path="/" exact><Main /></Route>
                            <Route component={NotFound} />
                            {/* <Route path="/category?/:title?" exact>
                            <Main />
                            <Route path="/signup">
                                <SignUp />
                            </Route>
                            <Route path="/signin">
                                <SignIn />
                            </Route>
                        </Route> */}                        
                        </Switch>                        
                    </main>
                    {popup}
                </ScrollToTop>
            </AppContext.Provider>
        </BrowserRouter>
    )
}
export default App